import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpEndMedicalLeaveRequest = () => {
    const { t } = useTranslation('medicalLeaveRequest');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const endMedicalLeaveRequest = (id: string, endDate: string, callback: ICallback) => {
        const { exec, abort } = userApi.endRequest({
            params: { id, endDate },
            onSuccess: () => {
                toastHandler.push(
                    'success',
                    t('notifications.endMedicalLeaveRequestTitle'),
                    t('notifications.endMedicalLeaveRequestSucceededMessage')
                );
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => {
                toastHandler.push('error', t('notifications.endMedicalLeaveRequestTitle'), t('notifications.endMedicalLeaveRequestFailedMessage'));
                if (callback.onError) callback.onError?.(error);
                else console.error(error);
            },
        });

        exec();
        return abort;
    };

    return { endMedicalLeaveRequest };
};

export default useHttpEndMedicalLeaveRequest;
